var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 2.28979H5.83317C3.53198 2.28979 1.6665 4.15527 1.6665 6.45646V14.7898C1.6665 17.091 3.53198 18.9565 5.83317 18.9565H14.1665C16.4677 18.9565 18.3332 17.091 18.3332 14.7898V6.45646C18.3332 4.15527 16.4677 2.28979 14.1665 2.28979Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 10.0981C13.4361 10.7916 13.3176 11.4999 12.9947 12.1222C12.6718 12.7446 12.1609 13.2492 11.5346 13.5644C10.9083 13.8797 10.1986 13.9894 9.50641 13.878C8.81419 13.7666 8.17472 13.4398 7.67895 12.944C7.18318 12.4483 6.85636 11.8088 6.74497 11.1166C6.63359 10.4243 6.74331 9.71463 7.05852 9.08837C7.37374 8.4621 7.87841 7.95117 8.50074 7.62826C9.12307 7.30534 9.83138 7.18688 10.5249 7.28972C11.2324 7.39462 11.8873 7.72427 12.393 8.22998C12.8987 8.73568 13.2283 9.39062 13.3333 10.0981Z",
    stroke: "#07070C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5835 6.03979H14.5918",
    stroke: "#07070C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramWhite);
export default __webpack_public_path__ + "static/media/instagramWhite.5cd45580e33b4f533fb91cc84f4a49c1.svg";
export { ForwardRef as ReactComponent };